import React from 'react';
import AddonsDetail from '@/components/AddonsDetail';
import { TFareRuleV2 } from '@/slices/flightData/slices';

interface TripDetailListAddonsProps {
  selectedFlightProps: any,
  fareRule: TFareRuleV2,
  duration: number;
  onViewRefundRule: () => void;
  onViewUpdateRule: () => void

}

const TripDetailListAddons: React.FC<TripDetailListAddonsProps> = ({
  selectedFlightProps,
  fareRule,
  duration,
  onViewRefundRule,
  onViewUpdateRule,
}) => {
  if (!fareRule) return <div />;
  return (
    <AddonsDetail
      selectedFlightProps={selectedFlightProps}
      duration={duration}
      fareRule={fareRule}
      onViewRefundRule={onViewRefundRule}
      onViewUpdateRule={onViewUpdateRule}
    />

  );
};

export default TripDetailListAddons;
